var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-wrapper", class: _vm.classObj },
    [
      _vm.device === "mobile" && _vm.sidebar.opened
        ? _c("div", {
            staticClass: "drawer-bg",
            on: { click: _vm.handleClickOutside },
          })
        : _vm._e(),
      _c("sidebar", { staticClass: "sidebar-container" }),
      _c(
        "div",
        { staticClass: "main-container" },
        [
          _c(
            "div",
            { class: { "fixed-header": _vm.fixedHeader } },
            [_c("navbar")],
            1
          ),
          _c("app-main"),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dk-container global-progress",
          class: { "is-collpase": _vm.$store.state.boarddata.global_collapse },
        },
        [
          _c(
            "div",
            {
              staticClass: "dk-container collapse-button",
              on: { click: _vm.handleClick_collapse },
            },
            [_vm._v("☺")]
          ),
          _c(
            "div",
            [
              _c("el-input", {
                staticStyle: { "margin-top": "1px", "margin-bottom": "1px" },
                attrs: { clearable: "", placeholder: "搜索主板名称" },
                model: {
                  value: _vm.search_name,
                  callback: function ($$v) {
                    _vm.search_name = $$v
                  },
                  expression: "search_name",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dk-container content" },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.filterBoard, stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: _vm.generateTitle("p99_sdb_tt_bd"),
                      "header-align": "center",
                      width: "140",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: _vm.generateTitle("p99_sdb_tt_pgs"),
                      "header-align": "center",
                      width: "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-progress", {
                              attrs: { percentage: scope.row._progress },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }